export enum SearchFilterTypes {
    OFFER_TYPE,
    MULTI_CHECKBOX,
    SELECT_RANGE,
    RANGE,
    RADIO,
    BUDGET
}
export enum SearchFilterTypes {
    OFFER_TYPE,
    MULTI_CHECKBOX,
    SELECT_RANGE,
    RANGE,
    RADIO,
    BUDGET
}
